module.exports = __webpack_public_path__ + "img/logo-github.f54e8f7f.svg";